module.exports = __webpack_public_path__ + "static/media/icon-visao.7a560d54.svg";